export const quoteCardBorder = 'border-[#e9ecef]';

export const quoteTableChrome = {
  card: `rounded border ${quoteCardBorder} bg-white`,
  gatedRow: 'blur-sm opacity-60 select-none',
  headerRow: 'border-b border-gray-100 bg-gray-50',
  sectionCell: 'px-3 py-1.5 text-xs font-bold uppercase tracking-wider text-bzblue-1000',
  sectionRow: 'border-b border-gray-200 bg-bzblue-300',
  table: 'w-full min-w-max text-sm',
  td: 'px-3 py-2 whitespace-nowrap text-sm',
  th: 'px-3 py-2 text-xs font-semibold text-gray-500 whitespace-nowrap',
  wrapper: `overflow-x-auto rounded border ${quoteCardBorder}`,
} as const;

export const quoteRowClass = (index: number, blurred?: boolean, extra?: string): string => {
  const parts = [`border-b border-gray-100`, index % 2 === 1 ? 'bg-gray-50' : '', blurred ? quoteTableChrome.gatedRow : '', extra ?? ''];
  return parts.filter(Boolean).join(' ');
};

export const quoteRowIsGated = (isGated: boolean, index: number, visibleRowCount: number): boolean =>
  isGated && index >= visibleRowCount;
